import ReactIcon from '@ant-design/icons-react';
export function setTwoToneColor(primaryColor) {
    return ReactIcon.setTwoToneColors({
        primaryColor: primaryColor
    });
}
export function getTwoToneColor() {
    var colors = ReactIcon.getTwoToneColors();
    return colors.primaryColor;
}


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/icon/twoTonePrimaryColor.js
// module id = null
// module chunks = 